import { CSSProperties } from "react";
import { OptionsType, Styles } from "react-select";

export * from "./ApiService";
export * from "./AppInformation";


export const ResourceType = {
  Video: "video",
  PDF: "pdf",
  Document: "document",
  Archive: "archive",
  Image: "image",
  Audio: "audio",
  Link: "link",
  Article: "article",
  Other: "other",
  Quiz: "quiz",
  Scorm: "scorm",
};

export const SessionContentType = {
  ...ResourceType,
};

// export const defaultStyleCombobox: Partial<Styles<OptionsType<Selection>,false>> = {
//   option: (styles: CSSProperties) => ({
//     ...styles,
//     textAlign: 'left',
//     zIndex: 9999,
//     fontSize: 14,
//   }),
//   control: (styles: CSSProperties) => ({
//     ...styles,
//     textAlign: 'left',
//     fontSize: 14,
//     borderRadius: 6
//   }),
//   menuPortal: (base: CSSProperties) => ({ ...base, zIndex: 9999 }),
//   menu: (base: CSSProperties) => ({ ...base, zIndex: 9999 }),
//   input: (styles: CSSProperties) => ({
//     ...styles,
//     fontSize: 14,
//   }),
// };